import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

export class WorkspacesPath extends BaseRouteConfig {
  public readonly Index = 'workspaces';

  public readonly List = new ACDLRoute<{ workspaceId: string }>(`${this.Path}/list`);
}
